<div class="dialoghead">
  <h1 class="mat-mdc-dialog-title">
    {{ slotData.subscribed ? 'Manage Subscription' : 'Subscription Options' }}
  </h1>
  <mat-dialog-content>
    <p *ngIf="slotData.subscribed">
      You are currently subscribed to this event. How would you like to update
      your subscription?
    </p>
    <p *ngIf="!slotData.subscribed">
      Choose how you would like to subscribe to this event.
    </p>
  </mat-dialog-content>
  <mat-dialog-actions *ngIf="slotData.subscribed">
    <button
      mat-button
      (click)="handleAction('unsubscribe', 'single')"
      [disabled]="isLoading"
    >
      Unsubscribe Single Event
    </button>
    <button
      mat-button
      (click)="handleAction('unsubscribe', 'series')"
      [disabled]="isLoading"
    >
      Unsubscribe Series of Event
    </button>
  </mat-dialog-actions>
  <mat-dialog-actions *ngIf="!slotData.subscribed">
    <button
      mat-button
      (click)="handleAction('subscribe', 'single')"
      [disabled]="isLoading"
    >
      Subscribe Single Event
    </button>
    <button
      mat-button
      (click)="handleAction('subscribe', 'series')"
      [disabled]="isLoading"
    >
      Subscribe Series of Event
    </button>
  </mat-dialog-actions>
  <ng-container *ngIf="isLoading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </ng-container>
</div>

<span mat-button mat-dialog-close class="close-btn-modal material-icons"
  >close</span
>
